export default function(data) {
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '\n  ';
 if (data.issues.length) { ;
__p += '\n    ';
 _.each(data.issues, function(issue) { ;
__p += '\n      <div class="grid-row issue label-' +
((__t = ( issue.stateClass )) == null ? '' : __t) +
' js-IssueList">\n        <article class="grid-cell x2 issue-description js-issue-desc">\n            <a href="/issues/' +
((__t = ( issue.number )) == null ? '' : __t) +
'">\n              <span class="issue-number js-issue-number">Issue ' +
((__t = ( issue.number )) == null ? '' : __t) +
'</span> <br />\n              <span class="issue-url issue-type js-issue-title">' +
__e( issue.title ) +
'</span> <br />\n            </a>\n          <p>\n            <span class="issue-date-open js-issue-date">Opened: <time>' +
((__t = ( issue.createdAt )) == null ? '' : __t) +
'</time></span>\n            <span class="issue-comments js-issue-comments">Comments: ' +
((__t = ( issue.commentNumber )) == null ? '' : __t) +
'</span>\n          </p>\n        </article>\n        <aside class="grid-cell x1 issue-labels">\n          ';
 _.each(issue.labels, function(label) { ;
__p += '\n            <span class="label js-Issue-label label-' +
((__t = ( label.remoteName )) == null ? '' : __t) +
'">\n              <a href="/issues?q=label:' +
((__t = ( label.remoteName )) == null ? '' : __t) +
'"\n                 data-remotename="' +
((__t = ( label.remoteName )) == null ? '' : __t) +
'"\n                 title="Labels : ' +
((__t = ( label.name )) == null ? '' : __t) +
'">' +
((__t = ( label.name )) == null ? '' : __t) +
'</a>\n            </span>\n          ';
 }); ;
__p += '\n        </aside>\n      </div>\n    ';
 }); ;
__p += '\n  ';
 } else { ;
__p += '\n  <div class="grid-row">\n    <article class="grid-cell x3">\n      <p>Nothing here currently, go report something!</p>\n    </article>\n  </div>\n';
 } ;
__p += '\n\n';
return __p
}